import React from "react";
import Header from "./Header";
import Footer from "./Footer";
import { useLocation } from "react-router-dom";
import PageSEO from "../PageSEO";

const EXACT_TITLES = {
  "/": "Home",
  "/ai": "AI Services",
  "/what-we-do": "What We Do",
  "/industries": "Industries",
  "/resources": "Resources",
  "/resources/case-studies": "Case Studies",
  "/resources/blogs": "Blogs",
  "/about": "About",
  "/about/company": "About Company",
  "/about/leadership": "Leadership",
  "/about/partners": "Partners",
  "/about/life-at-infotech": "Life At Infotech",
  "/careers": "Careers",
  "/contact": "Contact",
  "/privacy-notice": "Privacy Notice",
  "/terms": "Terms",
};

const toTitleCase = (value) =>
  value
    .split("-")
    .map((word) => {
      const upper = word.toUpperCase();
      if (["AI", "API", "IOT", "IT", "HR"].includes(upper)) {
        return upper === "IOT" ? "IoT" : upper;
      }
      return word.charAt(0).toUpperCase() + word.slice(1);
    })
    .join(" ");

const getTitleFromPathname = (pathname) => {
  if (EXACT_TITLES[pathname]) {
    return EXACT_TITLES[pathname];
  }

  const segments = pathname.split("/").filter(Boolean);
  if (!segments.length) return "Home";

  return toTitleCase(segments[segments.length - 1]);
};
const Layout = ({ children }) => {
  const { pathname } = useLocation();
  const title = getTitleFromPathname(pathname);

  // Admin pages use their own full-screen layout (no public header/footer)
  const isAdminRoute = pathname.startsWith("/admin");

  if (isAdminRoute) {
    return (
      <div className="min-h-screen">
        <PageSEO title={title} />
        {children}
      </div>
    );
  }

  return (
    <div className="min-h-screen flex flex-col">
      <PageSEO title={title} />
      <Header />
      <main className="flex-grow pt-16 md:pt-20">{children}</main>
      <Footer />
    </div>
  );
};

export default Layout;
